var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "home",
    d: "M21.909,9.569l0,0L12.932.593a2.025,2.025,0,0,0-2.865,0L1.1,9.563l-.009.009a2.024,2.024,0,0,0,1.348,3.451c.021,0,.042,0,.063,0h.358v6.6A2.373,2.373,0,0,0,5.226,22H8.738a.645.645,0,0,0,.645-.645V16.178A1.083,1.083,0,0,1,10.464,15.1h2.071a1.083,1.083,0,0,1,1.082,1.081v5.178a.645.645,0,0,0,.645.645h3.511a2.373,2.373,0,0,0,2.371-2.37v-6.6h.332a2.026,2.026,0,0,0,1.434-3.457ZM21,11.521a.732.732,0,0,1-.521.216H19.5a.645.645,0,0,0-.645.645V19.63a1.083,1.083,0,0,1-1.082,1.081H14.906V16.178a2.373,2.373,0,0,0-2.371-2.37H10.464a2.373,2.373,0,0,0-2.371,2.37v4.533H5.226A1.083,1.083,0,0,1,4.145,19.63V12.381a.645.645,0,0,0-.645-.645h-.99A.735.735,0,0,1,2,10.479H2L10.979,1.5a.736.736,0,0,1,1.041,0l8.973,8.972,0,0A.738.738,0,0,1,21,11.521Zm0,0",
    transform: "translate(-0.499)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d9381c680a4a5a3a9139f26748dc5f76.svg";
export { ForwardRef as ReactComponent };